import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class EventContactService extends BaseService {
  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/contacts`);
  }

  update(contactId: string | number, body: any, urlParams: any, apiParams: any = {}): Observable<any> {
    const url = sprintf(this.baseUrl, urlParams) + `/${contactId}`;
    return this.http.put<any>(url, body, { params: this.toHttpParams(apiParams) });
  }

  archive(contactId: string | number, urlParams: any, apiParams: any = {}): Observable<any> {
    const url = sprintf(this.baseUrl, urlParams) + `/${contactId}`;
    return this.http.delete<any>(url, { params: this.toHttpParams(apiParams) });
  }
}
